var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isLogged)?_c('dashboard-core-app-bar'):_vm._e(),(_vm.isLogged)?_c('dashboard-core-drawer',{attrs:{"expand-on-hover":_vm.expandOnHover}}):_vm._e(),_c('dashboard-core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }